import campaignReducer from './campaignSlice';
import currencyReducer from './currencySlice';
import trackingReducer from './trackingSlice';

export { default as campaignActions } from './campaignSlice';
export { setCurrencyLoading, setCurrencyData, resetCurrency } from './currencySlice';
export { setSource, selectSource, selectIsChopeCloud, SOURCE_CHOPE_CLOUD } from './trackingSlice';
export type { CurrencyState } from './currencySlice';
export type { TrackingState } from './trackingSlice';

export const reducers = {
  campaign: campaignReducer,
  currency: currencyReducer,
  tracking: trackingReducer,
};
